import { render, staticRenderFns } from "./SkuDetailView.vue?vue&type=template&id=7022060d&"
import script from "./SkuDetailView.vue?vue&type=script&lang=js&"
export * from "./SkuDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports